import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';

const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
  {
    dataField: 'DocumentNumber',
    caption: 'Quote',
    allowResizing: true,
    minWidth: 150,
    width: 150,
    fixed: true,
  },
  {
    dataField: 'SalesEntity',
    caption: 'Sales Entity',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: true,
  },
  {
    dataField: 'QuoteDate',
    caption: 'Entered',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'Expiry',
    caption: 'Expiry',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'Description',
    caption: 'Description',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'Status',
    caption: 'Status',
    allowResizing: true,
    minWidth: 100,
    width: 100,
    fixed: false
  },
  {
    dataField: 'CustomerName',
    caption: 'Customer Name',
    allowResizing: true,
    minWidth: 200,
    width: 200,
    fixed: false
  },
];

export const customerQuoteEnquiryLookupConstants: ICustomLookupOptions = {
  columns: LOOKUP_COLUMNS,
  dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
  hideColumnHeaders: false,
  disableGridColumnLines: false,
  dataPrefix: 'Details',
  tabbedLookup: {
    isTabbedLookup: true,
  }
};
